module.exports = __webpack_public_path__ + "static/img/logo-bigger.7458dc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-bigger.png
// module id = T/Oc
// module chunks = 1